<template>
  <button
    type="button"
    class="consultant-primary-btn"
    :class="[{ 'consultant-primary-btn--compact': compact }, customClass]"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="icon" aria-hidden="true"></i>
    <span v-if="loading" class="consultant-primary-btn__spinner" aria-hidden="true"></span>
    <slot>{{ label }}</slot>
  </button>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    label: {
      type: String,
      default: 'Add New Consultant',
    },
    icon: {
      type: String,
      default: 'bi bi-plus-lg',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    /** Smaller padding for tables and dense toolbars */
    compact: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
};
</script>

<style src="../styles/PrimaryButton.css"></style>
